import { render } from "./ActionSection.vue?vue&type=template&id=5db84bf8"
import script from "./ActionSection.vue?vue&type=script&lang=js"
export * from "./ActionSection.vue?vue&type=script&lang=js"
script.render = render

export default script